/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataReturnGoodsDto } from './NodataReturnGoodsDto';
import {
    NodataReturnGoodsDtoFromJSON,
    NodataReturnGoodsDtoFromJSONTyped,
    NodataReturnGoodsDtoToJSON,
    NodataReturnGoodsDtoToJSONTyped,
} from './NodataReturnGoodsDto';

/**
 * 
 * @export
 * @interface PageDataNodataReturnGoodsDto
 */
export interface PageDataNodataReturnGoodsDto {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataNodataReturnGoodsDto
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataNodataReturnGoodsDto
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataNodataReturnGoodsDto
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<NodataReturnGoodsDto>}
     * @memberof PageDataNodataReturnGoodsDto
     */
    records?: Array<NodataReturnGoodsDto>;
}

/**
 * Check if a given object implements the PageDataNodataReturnGoodsDto interface.
 */
export function instanceOfPageDataNodataReturnGoodsDto(value: object): value is PageDataNodataReturnGoodsDto {
    return true;
}

export function PageDataNodataReturnGoodsDtoFromJSON(json: any): PageDataNodataReturnGoodsDto {
    return PageDataNodataReturnGoodsDtoFromJSONTyped(json, false);
}

export function PageDataNodataReturnGoodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataNodataReturnGoodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(NodataReturnGoodsDtoFromJSON)),
    };
}

export function PageDataNodataReturnGoodsDtoToJSON(json: any): PageDataNodataReturnGoodsDto {
    return PageDataNodataReturnGoodsDtoToJSONTyped(json, false);
}

export function PageDataNodataReturnGoodsDtoToJSONTyped(value?: PageDataNodataReturnGoodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(NodataReturnGoodsDtoToJSON)),
    };
}

